<template>
  <div>
    <div>
      <h4>Доп. материал</h4>
      <materials :id="id" />
    </div>
    <hr />
    <Div>
      <h4>Темы</h4>
      <themes :id="id" />
    </Div>
  </div>
</template>
<script>
import Themes from "./Themes.vue";
import Materials from "./Materials.vue";
export default {
  components: { Materials, Themes },
  name: "products",
  props: ["id"],
  created() {},
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {};
  },
};
</script>
<style>
</style>
